import { ModelID } from '@core/shared/ModelID';
import { AxiosRequest } from '@infrastructure/axios';
import { IInvoiceService,PreviewInvoice } from '../types';

export default class InvoiceService implements IInvoiceService {
  async getById(id: ModelID, controller: AbortController): Promise<PreviewInvoice> {
    const response = await AxiosRequest.get<PreviewInvoice>(`/invoices/${id}`, { signal: controller.signal });
    return response.data.data;
  }

  async downloadInvocieById(id:ModelID,controller:AbortController): Promise<any>{
    const response = await AxiosRequest.get<any>(`/invoices/${id}/download`,{signal:controller.signal,responseType:'blob'});
    return  response.data
  }

}
